import axios from "axios"
import { Nullable, RuleType } from "../../types"

export interface IUpdateRuleParams {
    id: number,
    fields: {
        type: RuleType
        name: string,
        startDateTime: string,
        endDateTime: string | null,
        skip: number,
        applyFor: number | null,
        mailingList: string[] | null,
        alertOnSetting: boolean | null,
        alertOnActivation: boolean | null,
        pickupDateTimeFrom: Nullable<{
            value: string,
            excluded: boolean
        }>,
        pickupDateTimeTo: Nullable<{
            value: string,
            excluded: boolean
        }>,
        dropoffDateTimeFrom: Nullable<{
            value: string,
            excluded: boolean
        }>,
        dropoffDateTimeTo: Nullable<{
            value: string,
            excluded: boolean
        }>,
        includingDateTimeFrom: Nullable<{
            value: string,
            excluded: boolean
        }>,
        includingDateTimeTo: Nullable<{
            value: string,
            excluded: boolean
        }>,
        pickupLocations: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        dropoffLocations: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        pickupAreas: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        dropoffAreas: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        pickupRegions: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        dropoffRegions: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        pickupZones: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        dropoffZones: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        acrissList: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        sippList: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        customerCodes: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        salesChannels: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        segments: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        categories: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        products: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        rates: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        ancillaries: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        minDuration: Nullable<{
            value: number,
            excluded: boolean
        }>,
        maxDuration: Nullable<{
            value: number,
            excluded: boolean
        }>,
        minNoticeDays: Nullable<{
            value: number,
            excluded: boolean
        }>,
        maxNoticeHours: Nullable<{
            value: number,
            excluded: boolean
        }>,
        tenants: Nullable<{
            value: string[],
            excluded: boolean
        }>,
        dealers: Nullable<{
            value: string[],
            excluded: boolean
        }>,
    }
}

export const updateRule = async (params: IUpdateRuleParams) => {
    const response = await axios.put(`/booking/rule/${params.id}`, params.fields);
    return response.data;
}